import React from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';

import apiUrls from '../../common/api/api-urls';
import { trans } from '../../common/utils';
import { languages } from '../../configs/i18n';
import dataGridDefaultSettings from '../../components/datagrid-settings';
import { Template } from 'devextreme-react/core/template';
import LanguageTemplate from '../../components/language-template';

const MenuOperationPage = ({
    store: {
        languages: { table },
    },
}) => {
    return (
        <div className="operation">
            <DataGrid
                {...dataGridDefaultSettings({
                    settingStorageName: 'BMA_grid_menu_operation_USERID',
                    url: apiUrls.menu.operation,
                    toolbarCenter: `${useLocation().pathname}`,
                    key: 'operationId',
                    language: languages.languageId[table],
                    editing: {
                        allowDeleting: true,
                        allowUpdating:true,
                        allowAdding:true
                    },
                    editorPreparingArray: ['operationId', 'defaultName'],
                })}
            >
                <Column
                    dataField={'operationId'}
                    caption={trans('ID')}
                    dataType={'number'}
                    width={100}
                    sortOrder={'asc'}
                    allowEditing={false}
                    allowSearch={false}
                />

                <Column
                    dataField={'defaultName'}
                    caption={trans('Название по умолчанию')}
                    dataType={'string'}
                />

                <Column
                    dataField={'name'}
                    caption={`${trans('Название операции',)} (${table.toUpperCase()})`}
                    dataType={'string'}
                />

                <Column
                    dataField={'note'}
                    caption={trans('Примечание')}
                    dataType={'string'}
                />

                <Column
                    dataField={'command'}
                    caption={trans('Ссылка')}
                    dataType={'string'}
                />

                <Column
                    dataField={'isActive'}
                    caption={trans('Активный?')}
                    dataType={'boolean'}
                    width={150}
                    allowSearch={false}
                />

                <Column
                    dataField={'idt'}
                    caption={trans('Дата вставки')}
                    dataType={'datetime'}
                    format={'dd/MM/yy HH:mm:ss'}
                    width={170}
                    allowEditing={false}
                    allowSearch={false}
                />

                <Column
                    dataField={'udt'}
                    caption={trans('Дата обновления')}
                    dataType={'datetime'}
                    format={'dd/MM/yy HH:mm:ss'}
                    width={170}
                    allowEditing={false}
                    allowSearch={false}
                />
                <Column
                    caption={''}
                    width={50}
                    visible={true}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    allowReordering={false}
                    allowHiding={false}
                />
                <Template
                    name={'languageBar'}
                    render={() => <LanguageTemplate />}
                />

                <Paging defaultPageSize={10} enabled />
            </DataGrid>
        </div>
    );
};

export default inject('store')(observer(MenuOperationPage));
